import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminDashboard.css";

function AdminDashboard() {
  const [properties, setProperties] = useState([]);
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("isLoggedIn");
      navigate("/admin");
    }
  };

  useEffect(() => {

  const token = localStorage.getItem("token");

  // LOGIN CHECK
  if (!token) {
    navigate("/admin");
    return;
  }

  
  fetch("https://urbanbrick.in.net/get-properties.php")
    .then(res => res.json())
    .then(data => {

  const cleaned = data.map((item) => ({
    ...item,
    images: Array.isArray(item.images)
      ? item.images
      : item.images
        ? JSON.parse(item.images)
        : []
  }));

  setProperties(cleaned);

})
    .catch(err => console.log(err));

}, [navigate]);

  
    const handleDelete = (id) => {

  const confirmDelete = window.confirm(
    "Are you sure you want to delete this property?"
  );

  if (!confirmDelete) return;

  fetch("https://urbanbrick.in.net/delete-property.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ id })
  })
  .then(res => res.json())
  .then(data => {

    if (data.status === "success") {

      setProperties(prev =>
        prev.filter(item => item.id !== id)
      );

      alert("Deleted Successfully");

    } else {
      alert("Delete failed");
    }

  })
  .catch(err => {
    console.log(err);
    alert("Server error");
  });

};

  return (
    <div className="main-layout">

      {/* SIDEBAR */}
      <div className="sidebar">
        <h2 className="logo">🏠 RealEstate</h2>

        <ul>
          <li onClick={() => navigate("/admin/dashboard")}>Dashboard</li>
          <li onClick={() => navigate("/admin/properties")}>Properties</li>
          <li onClick={() => navigate("/admin/buys")}>Buys</li>
          <li onClick={() => navigate("/admin/sales")}>Sales</li>
          <li onClick={() => navigate("/admin/rents")}>Rents</li>
          <li onClick={() => navigate("/admin/messages")}>Messages</li>
          <li onClick={() => navigate("/admin/settings")}>Settings</li>
        </ul>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      {/* MAIN */}
      <div className="dashboard-container">

        {/* TOPBAR */}
        <div className="topbar">

          <div className="search-box">
            🔍 <input type="text" placeholder="Search..." />
          </div>

          <div className="topbar-right">
            🔔

            <div
              className="profile"
              onClick={() => document.getElementById("upload").click()}
            >

              {localStorage.getItem("profilePic") ? (
                <img
                  src={localStorage.getItem("profilePic")}
                  alt=""
                  className="profile-img"
                />
              ) : (
                <div className="avatar">
                  {localStorage.getItem("username")
                    ?.charAt(0)
                    .toUpperCase() || "A"}
                </div>
              )}

              <span>
                {localStorage.getItem("username") || "Admin"} ▾
              </span>

              <input
                type="file"
                id="upload"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  const reader = new FileReader();

                  reader.onloadend = () => {
                    localStorage.setItem("profilePic", reader.result);
                    window.location.reload();
                  };

                  if (file) reader.readAsDataURL(file);
                }}
              />

            </div>
          </div>

        </div>

        <div className="stats">

          <div className="card yellow">
            <p>Total Properties</p>
            <h2>{properties.length}</h2>
          </div>

          <div className="card pink">
            <p>Properties for Buy</p>
            <h2>150</h2>
          </div>

          <div className="card green">
            <p>Properties for Sale</p>
            <h2>130</h2>
          </div>

          <div className="card blue">
            <p>Properties for Rent</p>
            <h2>540</h2>
          </div>

          <div className="card orange">
             <p>Software Version</p>
             <h2>upcomming</h2>
          </div>

        </div>

        
        <div className="table-box">

          <div className="table-header">
            <h3>Property Listings</h3>

            <div className="table-actions">
              <input placeholder="Search properties..." />

              <button onClick={() => navigate("/add")}>
                + Add Property
              </button>

            </div>
          </div>

          {properties.length === 0 ? (
            <div className="empty-state">
              No properties added
            </div>
          ) : (

            <table>

              <thead>
                <tr>
                  <th>Property</th>
                  <th>Location</th>
                  <th>Price</th>
                  <th>Listing</th> 
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>

                {properties.map((p) => (

                  <tr key={p.id}>

                    <td className="property-cell">

                     <img
                          src={
  p.images?.[0]
    ? `https://urbanbrick.in.net/${p.images[0]}`
    : "https://via.placeholder.com/150"
}
                                alt="property"
                      />

                      <div>
                        <h4>{p.title}</h4>
                        <p>{p.type}</p>
                      </div>

                    </td>

                    <td>{p.location}</td>

                    <td>₹ {p.price}</td>

                    
                    <td>
                      <span className="status">
                        {p.listingType || "Buy"}
                      </span>
                    </td>

                    <td className="actions">

                      <button
                        className="view-btn"
                        onClick={() =>
                          navigate(`/property/${p.id}`)
                        }
                      >
                        View
                      </button>

                      <button
                        className="edit-btn"
                        onClick={() => {

                          const confirmEdit = window.confirm(
                            "Are you sure you want to edit this property?"
                          );

                          if (confirmEdit) {
                            navigate(`/edit/${p.id}`);
                          }

                        }}
                      >
                        Edit
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() =>
                          handleDelete(p.id)
                        }
                      >
                        Delete
                      </button>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          )}

        </div>

      </div>

    </div>
  );
}

export default AdminDashboard;